import React from "react";

const SocialMediaIcon = ({ icon, key }) => (
  <a className="mr-3" href={icon.href} target="blank" title={icon.title} key={key}>
    {icon.className && <i className={icon.className}></i>}
    {icon.customIcon && icon.customIcon}
  </a>
);

export default SocialMediaIcon;
